import { BrowserRouter, Navigate, Route, Routes } from 'react-router';
import { ToastContainer } from 'react-toastify';
import './App.css';
import './Financeiro.css';
import Browser from './components/browser/browser';
import Documentacao from './paginas/documentacao/Documentacao';
import Cadastro from './paginas/cadastro/cadastro';
import ConfirmacaoCadastro from './paginas/cadastro/confirmacaocadastro';
import HomePage from './paginas/home/home';
import Login from './paginas/login/login';
import { ZindexUtils } from './utils/zindexutils';

function App() {
  return (
    <>
      <ToastContainer position="top-right" style={{ zIndex: ZindexUtils.zIndexBar() + 1 }} />
      <div className="App">
        <BrowserRouter>
          <Routes>
            {/* Rota de Cadastro */}
            <Route path="/cadastro" element={<Cadastro />} /> 
            <Route path="/confirmacaocadastro" element={<ConfirmacaoCadastro />} /> 
            
            {/* Ajuste de Rota de Login:
               1. A rota base /login
               2. A rota dinâmica /login/:empresaParam (ex: /login/appcodesh)
            */}
            <Route path="/login" element={<Login />} />
            <Route path="/login/:empresaParam" element={<Login />} />
            
            {/* Redireciona a raiz para o login */}
            <Route path="/" element={<Navigate to="/login" replace />} />
            
            {/* Gestão Principal */}
            <Route path="/gestao" element={<Browser />} />

             <Route path="/home" element={<HomePage />} />
            <Route path="/documentacao" element={<Documentacao />} />

            {/* Fallback para rotas não encontradas (404) */}
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </BrowserRouter>
      </div>
    </>
  );
}

export default App;